module.exports = __webpack_public_path__ + "static/media/Intelligentrestaurant.88c153ed.jpg";